export default __webpack_public_path__ + "static/Vita Kurniati-660bcb16833837be0bf56e47728a5931.jpeg";